import {getMergeTagPreview} from '../../utils/api';
import merge from 'deepmerge';

const debounce = require('debounce');

export default {
  mounted() {
    this.seed = Math.floor(Math.random() * 1000000);
    this.debounce = debounce(this.updateText, 100);
  },
  methods: {
    updateText() {
      getMergeTagPreview(this.newVal, this.$route.params.msgId, this.seed).then(res => {
        if (!res.preview.length && res.error) {
          this.previewText = res.error;
        }
        else {
          this.previewText = res.preview[0];

          this.replacements = merge(this.replacements, res.replacements);
        }
      });
    },
  },
  watch: {
    'text': function(newVal) {
      this.newVal = newVal;

      if (!this.previewText && this.newVal) {
        //initial call
        this.updateText();
      }
      else {
        if (this.replacements.length) {
          this.replacements.map(replacement => {
            this.newVal = this.newVal.split(`[${replacement.name}]`).join(replacement.value);
          });
        }

        if (this.newVal.includes('[') && this.newVal.includes(']') && this.debounce) {
          this.debounce();
        }
        else {
          this.previewText = this.newVal;
        }
      }
    },
  },
  data() {
    return {
      debounce: null,
      previewText: '',
      replacements: [],
      seed: false,
      newVal: '',
    };
  },
};